
import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {Button, Form, Input, Icon, Checkbox} from 'antd';

class ClientsAddFormComponent extends Component {

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit} className="clients-add-form">
        <Form.Item>
          {getFieldDecorator('number', {
            rules: [
              { required: true, message: 'Пожалуйста введите номер машины!' }
              //todo: validate form
            ],
          })(
            <Input size="large" prefix={<Icon type="car" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Номер машины" />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('name')(
            <Input size="large" prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Имя" />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('phone')(
            <Input size="large" prefix={<Icon type="phone" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Телефон" />
          )}
        </Form.Item>
        <Form.Item>
          <Button size="large" type="primary" htmlType="submit" className="lg-btn" loading={this.props.loading}>
            Добавить
          </Button>
          <Button size="large" onClick={this.props.cancel} className="lg-btn" style={{marginLeft: 12}}>
            Отмена
          </Button>
        </Form.Item>
      </Form>
    );
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submit(values);
      }
    });
  }

}


export const ClientsAddForm = Form.create({ name: 'clients_add_form' })(ClientsAddFormComponent);



// WEBPACK FOOTER //
// ./src/components/pages/clients/forms/add.js